// 7.1.13 ToObject(argument)
var defined = require('./$.defined');
module.exports = function(it){
  return Object(defined(it));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-api-middleware/node_modules/core-js/library/modules/$.to-object.js
// module id = 819
// module chunks = 1 2 3